import { get } from 'lodash';
import * as uuid from 'uuid/v4';
import * as moment from 'moment'

import { fetch } from '@utils/utils';

const saveWorkplanEvidence = ({ addSuccess, addError }) => async (data: any): Promise<any | {}> => {
  const body = { ...data, id: data.id ? data.id : uuid() };
  try {
    const result: any = await fetch(`/metropolis/api/hr/workplan/evidence/${get(body, 'id')}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });
    addSuccess();
    return result.ok;
  } catch (err) {
    addError(err.message);
    return false;
  }
};

const getAllEvidences = async (employeeId?: any, selectedDay?: Date): Promise<any | {}> => {
  let filter = employeeId ? `?filter[0].field=employee.id&filter[0].operation=EQ&filter[0].value=${employeeId}` : '';
  const startOfMonth = moment(selectedDay).startOf('month').toISOString();
  const endOfMonth = moment(selectedDay).endOf('month').toISOString();
  if (employeeId && selectedDay) {
    filter += `&filter[1].field=from&filter[1].operation=GTE&filter[1].value=${startOfMonth}`;
    filter += `&filter[2].field=from&filter[2].operation=LTE&filter[2].value=${endOfMonth}&pageSize=31`;
  }
  if (filter === '') {
    filter += `?filter[0].field=from&filter[0].operation=GTE&filter[0].value=${startOfMonth}`;
    filter += `&filter[1].field=from&filter[1].operation=LTE&filter[1].value=${endOfMonth}&pageSize=31`;
  }
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/evidence${filter}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    return response.json();
  } catch (err) {
    return false;
  }
};

const getASingleEvidence = async (id: number): Promise<any | {}> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/evidence/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    return response.json();
  } catch (err) {
    return false;
  }
};

const deleteEvidence = ({ addSuccess, addError }) => async (id: number): Promise<any | {}> => {
  try {
    await fetch(`/metropolis/api/hr/workplan/evidence/${id}`, {
      method: 'DELETE',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });
    addSuccess('Interval byl vymazán');
    return true;
  } catch (err) {
    addError(err.message);
    return false;
  }
};

export { saveWorkplanEvidence, getAllEvidences, getASingleEvidence, deleteEvidence };



// WEBPACK FOOTER //
// ./src/modules/hr-overview/_myOverviewActions.ts